import * as fromRouter from '@ngrx/router-store';
import {RouterReducerState} from '@ngrx/router-store';
import {InjectionToken} from '@angular/core';
import {Action, ActionReducer, ActionReducerMap, createFeatureSelector, createSelector, MetaReducer} from '@ngrx/store';
import {environment} from '../../environments/environment';
import {localStorageSync} from 'ngrx-store-localstorage';
import {clearStateReducer, NgrxCoreReducer} from '@pt/pt-core';
import * as WorkspaceReducer from '../features/home/domains/workspace/store/reducers/workspace.reducer';
import {NgrxWidgetReducer} from '@pt/pt-shared';
import { WidgetState } from '@pt/pt-models';

export interface State {
  [NgrxCoreReducer.CORE_FEATURE_KEY]: NgrxCoreReducer.CoreState;
  [WorkspaceReducer.WORKSPACE_FEATURE_KEY]: WorkspaceReducer.WorkspaceState;
  [NgrxWidgetReducer.WIDGET_FEATURE_KEY]: WidgetState;
  router: fromRouter.RouterReducerState<any>;
}

export const ROOT_REDUCERS = new InjectionToken<ActionReducerMap<State, Action>>('Root reducers token', {
  factory: () => ({
    [NgrxCoreReducer.CORE_FEATURE_KEY]: NgrxCoreReducer.coreReducer,
    [WorkspaceReducer.WORKSPACE_FEATURE_KEY]: WorkspaceReducer.workspaceReducer,
    [NgrxWidgetReducer.WIDGET_FEATURE_KEY]: NgrxWidgetReducer.widgetReducer,
    router: fromRouter.routerReducer
  })
});


export const localStorageSyncReducer = (reducer: ActionReducer<any>): ActionReducer<any> => localStorageSync({
  keys:
    [
      NgrxCoreReducer.CORE_FEATURE_KEY,
      WorkspaceReducer.WORKSPACE_FEATURE_KEY,
      NgrxWidgetReducer.WIDGET_FEATURE_KEY
    ],
  rehydrate: true
})(reducer);

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? [localStorageSyncReducer, clearStateReducer]
  : [localStorageSyncReducer, clearStateReducer];


export const selectReducerState = createFeatureSelector<RouterReducerState<any>>('router');

export const selectCurrentRouterState = createSelector(
  selectReducerState,
  state => state ? state.state : null
);
